<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import { makeWebsiteRequest } from "../Common/tools";
  import {External, M} from "../external";

  export let id = 0;

  let order = null;
  let createdTime = "";

  let getImageSrc = (item) => {
    let src = External.resources + "/images/image-avatar.png";
    if (item.images && item.images.length > 0) {
      src = External.getThumbnailsFromBase(item.images[0].base, "160x120", true) + item.images[0].name;
    }
    return src;
  };

  let getVariation = (item) => {
    let variations = "";
    if (item.variation && item.variation.length) {
      variations = item.variation.map((variation) => variation.value).join(", ");
    }

    if (item.additions && item.additions.length) {
      if (variations !== "") {
        variations += ", ";
      }
      variations += item.additions.map((addition) => WebPlatform.escapeHtml(addition.name + ": " + addition.value)).join(", ");
    }
    return variations || "-";
  };

  let formatTime = (datetime) => {
    let dateFormatted = External.Tools.dateToShortString(datetime, true, true);
    let timeFormatted = External.Tools.timeToString(datetime, WebsiteSettings.getDateFormat() === "uk");
    return dateFormatted + " " + timeFormatted;
  };

  let setup = async () => {
    let response = await makeWebsiteRequest({
      action: "getOrderDetails",
      data: {
        id: id
      }
    });

    if (!response.data) {
      return;
    }
    order = response.data;
    let date = External.Tools.localDateTimeStringToDate(order.created);
    createdTime = formatTime(date);
  };

  onMount(setup);
</script>

{#if order}
  <div class="flex flex-col">
    <div class="account-settings store-products flex-1" in:fade>
      <div class="top-background-wrapper wide-top-background">
        <div class="top-background" style="max-width:1350px;">
          <div class="text-wrapper">
            <div class="col20 f-left">
              <h1 class="members-title f-left t-left"><i style="font-style: normal;">{M.ORDER} #{order.id}</i></h1>
              <span class="data-text">{createdTime}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="content-wrapper" style="max-width:1350px;">
        <div class="sections-wrapper profile-inner-wrapper">
          <div class="contact-profile-sidebar profile-sidebar">
            <section class="box-shadow">
              <h3 class="col20 f-left mb-25">{M.DETAILS}</h3>
              <label class="label">
                <h5>{M.NAME}</h5>
                <input class="readonly-input" type="text" readonly value={order.customerName} />
              </label>
              <label class="label">
                <h5>{M.EMAIL}</h5>
                <input class="readonly-input" type="text" readonly value={order.customerEmail} />
              </label>
              <label class="label">
                <h5>{M.TOTAL}</h5>
                <input class="readonly-input" type="text" value={External.Tools.currencyToStrWithSymbol(order.total)} readonly style="font-weight: bold" />
              </label>
            </section>
            {#if order.hasShipping}
              <section class="box-shadow">
                <h3 class="col20 f-left mb-25">{M.SHIPPING_DETAILS}</h3>
                <label class="label">
                  <h5>{M.PHONE}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.phone} />
                </label>
                <label class="label">
                  <h5>{M.COMPANY_NAME}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.companyName} />
                </label>
                <label class="label">
                  <h5>{M.COMPANY_ID}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.companyId} />
                </label>
                <label class="label">
                  <h5>{M.ADDRESS}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.address} />
                </label>
                <label class="label">
                  <h5>{M.CITY}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.city} />
                </label>
                <label class="label">
                  <h5>{M.STATE}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.state} />
                </label>
                <label class="label">
                  <h5>{M.POSTAL_CODE}</h5>
                  <input class="readonly-input" type="text" readonly value={order.shippingAddress.zipCode} />
                </label>
                <label class="label">
                  <h5>{M.COUNTRY}</h5>
                  <input class="readonly-input" type="text" readonly value={External.COUNTRIES[External.COUNTRY_CODES.indexOf(order.shippingAddress.country)]} />
                </label>
                <div class="col20 f-left none-soft" />
              </section>
            {/if}
            <section class="box-shadow">
              <h3 class="col20 f-left mb-25">{M.BILLING_DETAILS}</h3>
              <label class="label">
                <h5>{M.PHONE}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.phone} />
              </label>
              <label class="label">
                <h5>{M.COMPANY_NAME}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.companyName} />
              </label>
              <label class="label">
                <h5>{M.COMPANY_ID}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.companyId} />
              </label>
              <label class="label">
                <h5>{M.ADDRESS}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.address} />
              </label>
              <label class="label">
                <h5>{M.CITY}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.city} />
              </label>
              <label class="label">
                <h5>{M.STATE}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.state} />
              </label>
              <label class="label">
                <h5>{M.POSTAL_CODE}</h5>
                <input class="readonly-input" type="text" readonly value={order.billingAddress.zipCode} />
              </label>
              <label class="label">
                <h5>{M.COUNTRY}</h5>
                <input class="readonly-input" type="text" readonly value={External.COUNTRIES[External.COUNTRY_CODES.indexOf(order.billingAddress.country)]} />
              </label>
              <div class="col20 f-left none-soft" />
            </section>
          </div>
          <div class="contact-profile-content profile-content box-shadow">
            <h3 class="roboto">{M.PRODUCTS}</h3>
            <div class="col20 f-left mt-25">
              <div class="productsTable universal-table-wrapper">
                <div class="order-item">
                  {#if order.items.length}
                    <div class="scrollable-table orders-scrollable-table summary-scrollable-table">
                      <table style="margin-top: 0;">
                        <thead>
                          <tr class="flex flex-row align-center" style="padding-bottom: 0;">
                            <th class="flex-none mw-72"><a>{M.IMAGE}</a></th>
                            <th class="flex-none"><a>{M.PRODUCT}</a></th>
                            <th class="flex-none"><a>{M.VARIATION}</a></th>
                            <th class="flex-none mw-80"><a>{M.QUANTITY}</a></th>
                            <th class="flex-none"><a>{M.PRICE}</a></th>
                            <th class="flex-none"><a>{M.SKU}</a></th>
                          </tr>
                        </thead>
                        <tbody>
                          {#each order.items as item}
                            <tr class="flex flex-row align-center">
                              <td class="flex-none mw-72"><img src={getImageSrc(item)} style="max-width: 65px; border-radius: 6px;" /></td>
                              <td class="flex-none flex align-center">
                                {item.title}
                                {#if item.bump}
                                  <span title="Bump" class="material-icons-outlined product-order-type">add_box</span>
                                {:else if item.saleType === "UPSELL"}
                                  <span title="Upsell" class="material-icons-outlined product-order-type">arrow_upward</span>
                                {:else if item.saleType === "DOWNSELL"}
                                  <span title="Downsell" class="material-icons-outlined product-order-type">arrow_downward</span>
                                {/if}
                              </td>
                              <td class="flex-none">{getVariation(item)}</td>
                              <td class="flex-none mw-80">{item.quantity}</td>
                              <td class="flex-none" style="font-size: 15px;">{External.Tools.currencyToStrWithSymbol(item.price)}</td>
                              <td class="flex-none">{item.sku || "-"}</td>
                            </tr>
                          {/each}
                        </tbody>
                      </table>
                    </div>
                  {:else}
                    <h4>{M.NO_ITEMS_IN_ORDER}</h4>
                  {/if}
                  <div class="col20 f-left order-total-wrapper mt-15">
                    {#if order.discount}
                      <h4 class="f-left col20 mb-10 ta-right">
                        <span class="light-gray-text f-14-n mr-10 roboto">
                          {M.DISCOUNT_VALUE}
                          {order.discount.name} ({order.discount.code}):
                        </span>
                        {#if order.discountValue}
                          {External.Tools.currencyToStrWithSymbol(-order.discountValue)}
                        {/if}
                      </h4>
                    {/if}

                    <h4 class="f-left col20 mb-10 ta-right">
                      <span class="light-gray-text f-14-n mr-10 roboto">{M.SUBTOTAL}:</span>
                      {External.Tools.currencyToStrWithSymbol(order.subTotal)}
                    </h4>

                    {#each order.preShippingTaxes as tax}
                      <h4 class="f-left col20 mb-10 ta-right">
                        <span class="light-gray-text f-14-n mr-10 roboto">
                          {tax.name}
                          {#if tax.type === 0}
                            ({tax.amount}%)
                          {/if}
                          {#if External.Website.storePriceWithTax}
                            *{M.INCLUDED}*
                          {/if}
                          :
                        </span>
                        {External.Tools.currencyToStrWithSymbol(tax.total)}
                      </h4>
                    {/each}

                    {#if order.hasShipping && order.shipping}
                      <h4 class="f-left col20 mb-10 ta-right">
                        <span class="light-gray-text f-14-n mr-10 roboto">
                          {M.SHIPPING_COST} - {order.shipping.name}:
                        </span>
                        {External.Tools.currencyToStrWithSymbol(order.shipping.cost)}
                      </h4>
                    {/if}

                    {#each order.postShippingTaxes as tax}
                      <h4 class="f-left col20 mb-10 ta-right">
                        <span class="light-gray-text f-14-n mr-10 roboto">
                          {tax.name}
                          {#if tax.type === 0}
                            ({tax.amount}%)
                          {/if}
                          {#if External.Website.storePriceWithTax}
                            *{M.INCLUDED}*
                          {/if}
                          :
                        </span>
                        {External.Tools.currencyToStrWithSymbol(tax.total)}
                      </h4>
                    {/each}
                    <h4 class="f-left col20 ta-right mt-10 total-wrapper">
                      <span class="light-gray-text f-12-u mr-10 roboto">{M.TOTAL}:</span>
                      {External.Tools.currencyToStrWithSymbol(order.total)}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
